'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

RedirectionService=class RedirectionService extends BaseService{
constructor($state,$rootScope){
super();

this._$state=$state;
this._$rootScope=$rootScope;

this._helpCenterRedirectIsPending=!1;

$rootScope.$on('$stateChangeSuccess',(event,toState,toParams,fromState,fromParams)=>{
this._helpCenterRedirectIsPending=
toState.name==='fdc.features.login'&&
_.exists(toParams.return_to)&&
toParams.return_to.includes('/zendesk/login');
});
}

get helpCenterRedirectIsPending(){
return this._helpCenterRedirectIsPending;
}};


module.exports=RedirectionService;
//# sourceMappingURL=redirectionService.js.map
